import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Root container for client table rows
export const RootContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '72px',
  padding: '4px 8px',
  gap: '2px',
  overflow: 'hidden',
}));

// Full width row with space-between alignment
export const FullRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: '20px',
}));

// Bold row with ellipsis overflow
export const BoldRow = styled(Box)(() => ({
  fontWeight: 'bold',
  height: '20px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

// Bold text element with fixed minimum width
export const BoldText = styled(Box)(() => ({
  fontWeight: 'bold',
  minWidth: '90px',
  flexShrink: 0,
  textAlign: 'left',
}));

// Fixed width element with right alignment
export const FixedWidthText = styled(Box)(() => ({
  flex: 1,
  maxWidth: 'calc(100% - 100px)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'right',
  marginLeft: '4px',
}));

// Right-aligned text with ellipsis
export const RightText = styled(Box)(() => ({
  flex: 1,
  maxWidth: 'calc(100% - 100px)',
  textAlign: 'right',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  marginLeft: '4px',
}));

// Full width container
export const FullWidth = styled(Box)(() => ({
  width: "100%",
}));

// Table header background
export const TableHeader = styled(Box)(() => ({
  backgroundColor: "#bdbdbd",
}));

// Alternate row background
export const AlternateRow = styled(Box)(() => ({
  backgroundColor: "#efefef",
})); 